import React from 'react';
import styles from './Spinner.module.scss';

type SpinnerType = {
  className?: string;
}

const Spinner: React.FC<SpinnerType> = ({ className }) => {
  return (
    <img className={[styles.spinner, className].join(' ')} data-testid="spinner"
      src={`/images/icon-spinner.svg`} />
  );
}

export default Spinner;
